import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { KingClubAssets } from 'src/app/modules/shared/enum/icons';
import {
  GatewayDetail,
  GatewayGroup,
  PaymentConfig
} from 'src/app/modules/shared/models/gateway.model';
import { FormControl, Validators } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state(
        'void',
        style({
          height: '0px',
          overflow: 'hidden',
          opacity: 0
        })
      ),
      state(
        'collapsed',
        style({ height: '0', overflow: 'hidden', opacity: 0 })
      ),
      state('expanded', style({ height: '*', overflow: 'hidden', opacity: 1 })),
      transition('collapsed <=> expanded', animate('200ms ease-out'))
    ])
  ]
})
export class PaymentMethodsComponent implements OnInit, OnChanges {
  @Input() gatewayGroups: GatewayGroup[] = [];
  @Input() isLoggedIn: boolean = false;
  @Input() walletInsufficient: boolean = false;
  @Input() remaining: number = 0;
  @Input() mode: 'purchase' | 'wallet' = 'purchase';
  @Output() walletSelected = new EventEmitter<PaymentConfig>();
  @Output() gatewaySelected = new EventEmitter<GatewayDetail>();

  gateway: FormControl = new FormControl('', [Validators.required]);
  currency: FormControl = new FormControl('', [Validators.required]);
  network: FormControl = new FormControl('', [Validators.required]);
  kingAssets = KingClubAssets;
  paymentMethods: PaymentConfig[] = [
    {
      title: 'Wallet',
      value: 'wallet',
      description: 'Pay With King Wallet',
      expandable: false,
      expanded: false,
      data: {
        key: 'Balance',
        value: null,
        valueClass: 'balance-amount',
        errorClass: 'balance-error'
      },
      icon: 'assets/images/icons/wallet-gray.svg',
      iconClass: 'wallet-icon',
      error: null,
      errorClass: 'wallet-error',
      selected: false,
      isGateway: false,
      visible: true,
      hasPurchase: false,
      hasWallet: false,
      children: []
    }
  ];
  walletBalanceError = 'insufficient wallet balance';
  needLoginError = 'Please login to see your wallet balance';

  selectedPaymentMethod: PaymentConfig;
  selectedGateway: GatewayDetail;
  constructor() {}

  ngOnInit(): void {
    this.gateway.valueChanges.subscribe((value) => {
      this.selectedGateway = value;
      if (value) {
        this.gatewaySelected.emit(value);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['gatewayGroups']) {
      this.updatePaymentMethods();
    }

    if (changes['walletInsufficient'] || changes['remaining']) {
      this.paymentMethods[0] = {
        ...this.paymentMethods[0],
        data: {
          key: 'balance',
          value: this.remaining && this.isLoggedIn ? `${this.remaining}$` : `-`,
          valueClass: 'balance-amount',
          errorClass: 'balance-error'
        },
        error: this.walletInsufficient ? this.walletBalanceError : null
      };
    }
  }

  updatePaymentMethods() {
    if (this.gatewayGroups?.length > 0) {
      let arr = this.gatewayGroups?.map((group: GatewayGroup) => {
        return {
          title: group.title,
          description: group.description,
          value: group.id,
          expandable: group.gateways_detail?.length > 0,
          expanded: false,
          data: null,
          icon: '',
          iconClass: '',
          isGateway: true,
          visible: true,
          isList: true,
          hasPurchase: group.gateways_detail.some(
            (gw) => gw.can_use_for_purchase
          ),
          hasWallet: group.gateways_detail.some((gw) => gw.can_use_for_wallet),
          children: group.gateways_detail.map((gateway: GatewayDetail) => {
            return {
              gateway: gateway,
              selected: false
            };
          })
        };
      });
      this.paymentMethods = [...this.paymentMethods, ...arr];
    }

    this.paymentMethods[0] = {
      ...this.paymentMethods[0],
      error: this.getWalletError(),
      data: {
        key: 'balance',
        value: this.remaining && this.isLoggedIn ? `${this.remaining}$` : `-`,
        valueClass: 'balance-amount',
        errorClass: 'balance-error'
      }
    };
  }

  getWalletError(): string {
    if (!this.isLoggedIn) {
      return this.needLoginError;
    }
    if (this.walletInsufficient) {
      return this.walletBalanceError;
    }
    return null;
  }

  toggleExpandableMethod(i, event) {
    event.preventDefault();
    this.paymentMethods[i].expanded = !this.paymentMethods[i].expanded;
  }

  paymentMethodSelected(method: PaymentConfig, index: number) {
    if (method.value === 'wallet' && (this.walletInsufficient || method.error))
      return;
    this.selectedPaymentMethod = method;
    if (method.value === 'wallet') {
      this.selectedGateway = null;
      this.gateway.setValue(null);
      this.walletSelected.emit(method);
    }
  }

  gwGroupChange(event: MatRadioChange, method) {
    this.gateway.setValue(event.value);
    this.selectedGateway = event.value;
    this.selectedPaymentMethod = method;
  }
}
